import dell_outer from './dell-outer.png';
import dell_upper from './dell-upper.png';
import dell_inner from './dell-inner.png';

import hp_outer from './hp-outer.png';
import hp_inner from './hp-inner.png';
import hp_upper from './hp-upper.png';
export const IMAGES = [
    {
        "quality_classification": {
            "id": "7165398751379457",
            "image": `${dell_outer}`,
            "classification": {
                "result": {
                    "class": "HP_800_G1_SFF",
                    "score": "0.9625813961029053",
                    "bbox": "508,414,258,114"
                }
            },
            "feedback": ""
        }
    },
    {
        "quality_classification": {
            "id": "7165398751379457",
            "image": `${dell_inner}`,
            "classification": {
                "result": {
                    "class": "Case",
                    "score": "A",
                    "bbox": "0,0,1,1"
                }
            },
            "feedback": ""
        }
    },
    {
        "quality_classification": {
            "id": "7165398751379457",
            "image": `${dell_upper}`,
            "classification": {
                "result": {
                    "class": "Case",
                    "score": "A",
                    "bbox": "0,0,1,1"
                }
            },
            "feedback": ""
        }
    },
    {
        "quality_classification": {
            "id": "7165398751379458",
            "image": `${hp_outer}`,
            "classification": {
                "result": {
                    "class": "HP_800_G1_SFF",
                    "score": "0.9625813961029053",
                    "bbox": "508,414,258,114"
                }
            },
            "feedback": ""
        }
    },
    {
        "quality_classification": {
            "id": "7165398751379458",
            "image": `${hp_inner}`,
            "classification": {
                "result": {
                    "class": "Case",
                    "score": "A",
                    "bbox": "0,0,1,1"
                }
            },
            "feedback": ""
        }
    },
    {
        "quality_classification": {
            "id": "7165398751379458",
            "image": `${hp_upper}`,
            "classification": {
                "result": {
                    "class": "Case",
                    "score": "A",
                    "bbox": "0,0,1,1"
                }
            },
            "feedback": ""
        }
    }
]